import PartnerDetailsModalComponent from './partner-details-modal.component'

const PartnerDetailsModalModule = angular.module('cdbl.partner-details-modal', [

])
  .component('cdblPartnerDetailsModal', PartnerDetailsModalComponent)
  .name

export default PartnerDetailsModalModule
